let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7u7rT")).then(() => parcelRequire('hfEgP'));